function addJudgeMeOffset() {
  if (!globalThis.jdgmSettings) {
    globalThis.jdgmSettings = {};
  }
  const headerHeight = 75;
  globalThis.jdgmSettings.scrollTopOffset = headerHeight;
}

export { addJudgeMeOffset };
